import { logger } from '../../utils/logger';
import { parseSapCtiXml } from './cti-xml-parser';
import { performOutboundDial } from './outbound-dial.util';

export function handleCtiPostMessage(data: unknown): boolean {
  if (typeof data === 'string' && data.includes('<payload>')) {
    logger.debug('[SAP Context] Received XML message from SAP');
    const dialInfo = parseSapCtiXml(data);
    if (dialInfo) {
      logger.debug('[SAP Context] SAP dialout detected, phone:', dialInfo.phoneNumber);
      performOutboundDial(dialInfo.phoneNumber, { contactId: dialInfo.contactId });
      return true;
    }
  }

  const record = data as {
    PhoneNumber?: string;
    Direction?: string;
    ContactID?: string;
    contactId?: string;
    type?: string;
    phoneNumber?: string;
    skillId?: string;
  };

  if (record?.PhoneNumber && record?.Direction === 'OUT') {
    logger.debug('[SAP Context] SAP Sales Cloud dialout detected, phone:', record.PhoneNumber);
    performOutboundDial(record.PhoneNumber, {
      contactId: record.ContactID || record.contactId,
    });
    return true;
  }

  if (record?.type === 'CTI_DIAL' && record?.phoneNumber) {
    logger.debug('[SAP Context] CTI_DIAL received, phone:', record.phoneNumber);
    performOutboundDial(record.phoneNumber, {
      skillId: record.skillId,
      contactId: record.contactId,
    });
    return true;
  }

  return false;
}
